import { render, staticRenderFns } from "./asset-list.vue?vue&type=template&id=51011b51&"
import script from "./asset-list.vue?vue&type=script&lang=js&"
export * from "./asset-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports